import React, { useState } from "react";
import { Bicycle, ChevronLeft, TaxiFrontFill } from "react-bootstrap-icons";
import AccardionItem from "../Accardion/AccardionItem/AccardionItem";
import Style from "./Accardion14.module.scss";
const Accardion14 = () => {
  const [openAll , setOpenAll]=useState(false)

  const ItemList = [
    {
      id: "1",
      title: "همه درخواست های پیک",
      link: "/alldeliveryreq",
      active: window.location.pathname === "/alldeliveryreq",
    },
    {
      id: "2",
      title: "ضریب هزینه پیک",
      link: "/deliverycost",
      active: window.location.pathname === "/deliverycost",
    },
  ];

  let value = false;
  ItemList.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });

  const openHandlerAll=()=>{
    if(openAll){
      setOpenAll(false)
    }
    else{
      setOpenAll(true)
    }
  }
  return (
    <div className={Style.componentHolder}>
      <div
        className={value || openAll ? Style.background : Style.accardionTitle}
        onClick={openHandlerAll}
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}>پیک</p>
          <Bicycle />
        </div>
      </div>
      <div className={value ||openAll ? Style.inneraccardionContent : Style.hidden}>
        <AccardionItem accardonItem={ItemList && ItemList} />
      </div>
    </div>
  );
};

export default Accardion14;
